"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _moment = _interopRequireDefault(require("moment"));

var _moment2 = require("react-day-picker/moment");

var _DayPickerInput = _interopRequireDefault(require("react-day-picker/DayPickerInput"));

require("./styles.css");

var _lib = require("../../lib");

var _common = require("../../common");

var _Button = _interopRequireDefault(require("../Button"));

var _Icon = _interopRequireDefault(require("../Icon"));

var _Input = _interopRequireDefault(require("../Input"));

var _NavBar = _interopRequireDefault(require("./NavBar"));

var _Calendar = _interopRequireDefault(require("./Calendar"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var DatePicker =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(DatePicker, _PureComponent);

  // bulkConvert converts object all keys value to Date object
  function DatePicker(props) {
    var _this;

    _classCallCheck(this, DatePicker);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DatePicker).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "handleOnChange", function (day) {
      var _this$props = _this.props,
          name = _this$props.name,
          onChange = _this$props.onChange;

      if (day) {
        // check if really has valid day only setState
        _this.setState({
          value: day,
          displayDate: day
        }, function () {
          var format = _this.props.format; // if no format provided, return Date object

          var value = day;

          if (format || (0, _lib.isString)(format)) {
            value = (0, _moment.default)(day).format(format);
          }

          if (onChange) {
            onChange(null, {
              name: name,
              value: value
            });
          }
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnClear", function (e) {
      (0, _lib.callEventMethods)(e, 'preventDefault', 'stopPropagation');
      var displayDate = _this.props.displayDate;
      var newDisplayDate = DatePicker.getDateObj(displayDate);

      _this.setState({
        value: '',
        displayDate: newDisplayDate
      }, function () {
        var _this$props2 = _this.props,
            name = _this$props2.name,
            onChange = _this$props2.onChange,
            onClear = _this$props2.onClear;

        if (onChange) {
          onChange(e, {
            name: name,
            value: null
          });
        }

        if (onClear) {
          onClear(e, {
            name: name,
            value: null
          });
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnMonthChange", function (e, _ref) {
      var name = _ref.name,
          value = _ref.value;
      var displayDate = _this.state.displayDate;

      if (name === 'month' && value) {
        _this.setState({
          displayDate: new Date(displayDate.getFullYear(), value)
        });
      }

      if (name === 'year' && value) {
        _this.setState({
          displayDate: new Date(value, displayDate.getMonth())
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnMonthPrevious", function () {
      var displayDate = _this.state.displayDate;

      _this.setState({
        displayDate: new Date(displayDate.getFullYear(), displayDate.getMonth() - 1)
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnMonthNext", function () {
      var displayDate = _this.state.displayDate;

      _this.setState({
        displayDate: new Date(displayDate.getFullYear(), displayDate.getMonth() + 1)
      });
    });

    _defineProperty(_assertThisInitialized(_this), "classNames", function () {
      var propNames = ['fluid', 'extendable', 'disabled'];
      var names = [DatePicker.className];
      (0, _lib.addClassByPropName)(names, _this.props, propNames);

      _common.customClassNames.addTextAlign(names, _this.props.textAlign);

      return names.join(' ');
    });

    var _value = props.value,
        _displayDate = props.displayDate;
    var newValue = DatePicker.getDateObj(_value);

    var _newDisplayDate = DatePicker.getDateObj(_displayDate);

    _this.state = {
      prevProps: {
        value: _value,
        displayDate: _displayDate
      },
      value: newValue,
      displayDate: newValue || _newDisplayDate
    };
    return _this;
  }

  _createClass(DatePicker, [{
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          fluid = _this$props3.fluid,
          readOnly = _this$props3.readOnly,
          extendable = _this$props3.extendable,
          placeholder = _this$props3.placeholder,
          renderFormat = _this$props3.renderFormat,
          disabled = _this$props3.disabled,
          disabledDays = _this$props3.disabledDays,
          onClear = _this$props3.onClear,
          clearable = _this$props3.clearable,
          selectedDays = _this$props3.selectedDays,
          yearsLimit = _this$props3.yearsLimit,
          propDisplayDate = _this$props3.displayDate,
          propRest = _objectWithoutProperties(_this$props3, ["fluid", "readOnly", "extendable", "placeholder", "renderFormat", "disabled", "disabledDays", "onClear", "clearable", "selectedDays", "yearsLimit", "displayDate"]);

      var _this$state = this.state,
          value = _this$state.value,
          displayDate = _this$state.displayDate;
      var classNames = this.classNames();
      var disabledDates = DatePicker.bulkConvert(disabledDays);
      var selectedDates = DatePicker.bulkConvert(selectedDays);
      return _react.default.createElement(_DayPickerInput.default, {
        classNames: {
          container: classNames,
          overlay: 'DayPickerInput-Overlay',
          overlayWrapper: 'DayPickerInput-OverlayWrapper'
        },
        placeholder: placeholder || renderFormat,
        format: renderFormat,
        formatDate: _moment2.formatDate,
        parseDate: _moment2.parseDate,
        value: value,
        component: _Input.default,
        inputProps: _objectSpread({
          disabled: disabled,
          fluid: fluid,
          readOnly: readOnly,
          suffix: value && clearable && !readOnly ? _react.default.createElement(_Button.default, {
            className: "close-button",
            basic: true,
            color: "blue",
            icon: _react.default.createElement(_Icon.default, {
              name: _Icon.default.Close
            }),
            onClick: this.handleOnClear
          }) : _react.default.createElement(_Icon.default, {
            name: _Icon.default.Calendar,
            color: "blue"
          })
        }, propRest),
        dayPickerProps: {
          month: DatePicker.getDateObj(displayDate || new Date()),
          initialMonth: DatePicker.getDateObj(value || displayDate || new Date()),
          navbarElement: _react.default.createElement(_NavBar.default, _extends({}, this.props, this.state, {
            onChange: this.handleOnMonthChange,
            onNext: this.handleOnMonthNext,
            onPrevious: this.handleOnMonthPrevious
          })),
          onDayClick: function onDayClick(day, modifiers, e) {
            return (0, _lib.callEventMethods)(e, 'preventDefault', 'stopPropagation');
          },
          disabledDays: disabledDates,
          modifiers: {
            highlighted: selectedDates
          }
        },
        onDayChange: this.handleOnChange
      });
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      var prevProps = state.prevProps; // Compare the incoming prop to previous prop

      var value = props.value,
          displayDate = props.displayDate;
      var newValue = DatePicker.getDateObj(value);
      var newDisplayDate = DatePicker.getDateObj(displayDate);
      return {
        // Store the previous props in state
        prevProps: {
          value: value,
          displayDate: displayDate
        },
        value: prevProps.value !== value ? newValue : state.value,
        displayDate: prevProps.displayDate !== displayDate ? newValue || newDisplayDate : state.displayDate
      };
    }
  }]);

  return DatePicker;
}(_react.PureComponent);

exports.default = DatePicker;

_defineProperty(DatePicker, "Calendar", _Calendar.default);

_defineProperty(DatePicker, "className", 'MHub-DatePicker');

_defineProperty(DatePicker, "propTypes", {
  name: _propTypes.default.string,
  value: _common.customPropTypes.moment,
  onChange: _propTypes.default.func,
  onClear: _propTypes.default.func,
  textAlign: _common.customPropTypes.textAlign,
  fluid: _propTypes.default.bool,
  extendable: _propTypes.default.bool,
  readOnly: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  clearable: _propTypes.default.bool,
  selectedDays: _propTypes.default.shape({
    from: _common.customPropTypes.moment,
    to: _common.customPropTypes.moment
  }),
  disabledDays: _propTypes.default.oneOfType([_common.customPropTypes.moment, _propTypes.default.arrayOf(_common.customPropTypes.moment)]),
  displayDate: _common.customPropTypes.moment,
  yearsLimit: _propTypes.default.number,
  placeholder: _propTypes.default.string,
  format: _propTypes.default.string,
  renderFormat: _propTypes.default.string
});

_defineProperty(DatePicker, "defaultProps", {
  name: null,
  value: null,
  onChange: null,
  onClear: null,
  textAlign: null,
  fluid: false,
  extendable: false,
  readOnly: false,
  disabled: false,
  clearable: true,
  selectedDays: null,
  disabledDays: null,
  displayDate: new Date(),
  yearsLimit: 50,
  placeholder: null,
  format: null,
  renderFormat: 'DD / MM / YYYY' // getDateObj converts value to Date object

});

_defineProperty(DatePicker, "getDateObj", function (value) {
  if ((0, _lib.arrayHasItems)(value)) {
    // handle multiple
    return value.reduce(function (result, v) {
      if (v && (0, _moment.default)(v).isValid()) {
        result.push((0, _moment.default)(v).toDate());
      }

      return result;
    }, []);
  }

  if (value && (0, _moment.default)(value).isValid()) {
    // convert to date from moment obj
    return (0, _moment.default)(value).toDate();
  }

  return value;
});

_defineProperty(DatePicker, "bulkConvert", function (obj) {
  if ((0, _lib.objHasKeys)(obj)) {
    var keys = Object.keys(obj);
    var newObj = Object.assign({}, obj);

    if ((0, _lib.arrayHasItems)(keys)) {
      keys.forEach(function (k) {
        newObj[k] = DatePicker.getDateObj(obj[k]);
      });
    }

    return newObj;
  }

  return obj;
});